"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderRefundItem = void 0;
const class_validator_1 = require("class-validator");
const cloneModelObject_1 = require("../../../../apis/spg/util/cloneModelObject");
/**
 * An item and quantity that relates to a refund or an original sales order
 */
class SalesOrderRefundItem {
    filterSensitiveData() {
        const clone = (0, cloneModelObject_1.cloneModelObject)(this);
        return clone;
    }
    serialize() {
        return {
            quantity: this.quantity
        };
    }
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsNotEmpty)()
], SalesOrderRefundItem.prototype, "quantity", void 0);
exports.SalesOrderRefundItem = SalesOrderRefundItem;
//# sourceMappingURL=SalesOrderRefundItem.js.map